import { getErrorMessage } from 'utils/stringUtils';

import { types } from './actions';

const initialRegistrationState = {
  isFetching: false,
  isFetched: false,
  details: null,
  error: null,
};

const reducer = (state = initialRegistrationState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.REGISTRATION_REQUEST:
      return { ...state, isFetching: true, error: null };
    case types.REGISTRATION_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        error: getErrorMessage(payload),
      };
    default:
      return state;
  }
};

export default reducer;
